import styled from "styled-components";
import { device } from "../../Utils/device";
import { themes } from "../../Utils/themes";

export const Section = styled.div`
  padding-top: 60px;
  margin: 0px 20px 40px;
  @media ${device.desktop} {
    margin: 0px auto 60px;
    max-width: 1180px;
  }
`;

export const StyledSectionTitle = styled.h1`
  font-size: ${themes.textSize.m3};
  @media ${device.tablet} {
    font-size: ${themes.textSize.l1};
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.l2};
  }
`;

export const Pre = styled.div`
  border: 1px solid ${themes.colors.border};
  border-radius: 8px;
  padding: 20px;
`;

export const PreTitle = styled.li`
  font-size: 14px;
  color: ${themes.colors.text};
  font-weight: bold;
`;

export const PreLabel = styled.p`
  font-size: 12px;
  color: ${themes.colors.text};
  margin-top: 6px;
  margin-bottom: 6px;
`;
